import { ref } from 'vue'
import { useEventListener } from '@vueuse/core'

import type { Ref } from 'vue'

interface KeyboardInsetReturn {
  keyboardInset: Readonly<Ref<number>>
}

export const useKeyboardInset = (): KeyboardInsetReturn => {
  const keyboardInset = ref<number>(0)

  // iOS keeps the layout viewport when the on-screen keyboard opens, so the covered height is read from visualViewport.
  const measure = (): void => {
    const viewport = window.visualViewport
    if (!viewport) return

    keyboardInset.value = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
  }

  measure()
  useEventListener(() => window.visualViewport, ['resize', 'scroll'], measure, { passive: true })

  return {
    keyboardInset,
  }
}
